<template>
    <header
        class="header"
        :class="[
            { 'show-navi': $store.state.show_navi },
            { 'is-show-mobile-sub-menus': is_show_mobile_sub_menus }
        ]"
        @mouseover="showNavi(true)"
        @mouseleave="showNavi(false)"
    >
        <div class="mobile-item">
            <router-link to="/" id="mobile-stripe-logo"
                >Stripe Partners</router-link
            >
            <span @click="$store.state.show_navi = !$store.state.show_navi">
                <svg v-if="!$store.state.show_navi" viewBox="0 0 24 19">
                    <g transform="translate(-318 -607)">
                        <line
                            x2="24"
                            transform="translate(318 624.5)"
                            fill="none"
                            stroke="#fff"
                            stroke-width="3"
                        />
                        <line
                            x2="24"
                            transform="translate(318 616.5)"
                            fill="none"
                            stroke="#fff"
                            stroke-width="3"
                        />
                        <line
                            x2="24"
                            transform="translate(318 608.5)"
                            fill="none"
                            stroke="#fff"
                            stroke-width="3"
                        />
                    </g>
                </svg>
                <svg v-else viewBox="0 0 15.822 15.822">
                    <rect
                        width="2.304"
                        height="20.071"
                        transform="translate(0 1.629) rotate(-45)"
                        fill="#fff"
                    />
                    <rect
                        width="20.071"
                        height="2.304"
                        transform="translate(0 14.193) rotate(-45)"
                        fill="#fff"
                    />
                </svg>
            </span>
        </div>

        <div class="page-inner" v-if="navi && navi.length !== 0">
            <nav class="navi">
                <h1 class="logo">
                    <router-link to="/" id="desktop-logo">
                        <span>Stripe Partners</span>
                        <svg viewBox="0 0 180 100.9">
                            <path
                                d="M111.8,99.3V1.6h12.8c14.4,0,26.5,1.2,35.4,4.3c13.1,4.4,20,13.1,20,24.2c0,9.2-5.1,17.5-14.5,22.5 c-9.7,5.2-22.7,6.4-35.7,6.5v40.1H111.8z M129.9,41.3h3.7c14.8,0,28.5-2.4,28.5-11.1c0-8.4-13.5-10.8-28.2-10.8h-4V41.3z"
                            />
                            <path
                                d="M39.7,50.5c0.1,8.5,0.1,17.5-1.9,24c-1.6,5.2-4.7,8.1-8.5,8.1c-4.3,0-7.3-3.9-8.9-9.6 c-1.9-6.4-2.1-15.2-2.1-22.5H0C0,62,0.8,73,4.4,82.1c4.4,11.2,12.8,18.8,24.8,18.8c12.4,0,20.7-7.7,25-18.9 c3.5-8.8,3.9-18.7,3.7-31.4c-0.1-8.5-0.1-17.5,1.9-24c1.6-5.2,4.8-8.3,8.7-8.3c4.1,0,7.2,4,8.8,9.7c1.9,6.4,2.1,15.2,2.1,22.5h18.3 c0-11.5-0.8-22.5-4.4-31.6C88.9,7.7,80.6,0,68.6,0C56.2,0,47.8,7.9,43.4,19.1C40,28,39.6,37.7,39.7,50.5z"
                            />
                        </svg>
                    </router-link>
                </h1>
                <ul>
                    <li
                        v-for="item in navi"
                        :key="item.ID"
                        class="menu-item"
                        :class="[
                            'menu-' + item.object_slug,
                            { 'show-sub-menu': item.show_sub_menu }
                        ]"
                    >
                        <h3 @click="toogleMobileMenus(item)">
                            <span
                                v-if="item.url === '#onlytext'"
                                v-html="item.title"
                            ></span>
                            <Link
                                v-else
                                :link="item"
                                v-html="item.title"
                                :id="`${item.title}-nav`"
                            ></Link>
                        </h3>
                        <ul v-if="item.children">
                            <li
                                v-for="(sub_item, index) in item.children"
                                :key="index"
                                class="sub-menu-item"
                                :class="[
                                    'sub-menu-' + sub_item.object_slug,
                                    {
                                        'only-text':
                                            sub_item.url === '#onlytext' ||
                                            sub_item.url.indexOf('/news/') !==
                                                -1
                                    }
                                ]"
                            >
                                <span
                                    v-if="sub_item.url === '#onlytext'"
                                    v-html="sub_item.title"
                                ></span>
                                <Link
                                    v-else
                                    :link="sub_item"
                                    v-html="sub_item.title"
                                    :id="`${sub_item.title}-nav`"
                                ></Link>
                            </li>
                        </ul>
                    </li>
                </ul>

                <router-link
                    v-if="showBackHomeLink"
                    :class="{
                        'homepage-link': true,
                        'show-return-link': $store.state.show_navi
                    }"
                    to="/"
                    id="return-to-homepage-nav"
                    >Return to homepage</router-link
                >
                <Link
                    class="link"
                    v-if="link"
                    :post_link="link"
                    v-html="text"
                    :id="`${text}-nav`"
                />
            </nav>
            <nav class="menus" v-if="menus.length !== 0">
                <ul>
                    <li
                        v-for="item in menus"
                        :key="item.ID"
                        class="menu-item"
                        :class="['menu-' + item.object_slug]"
                    >
                        <span
                            v-if="item.url === '#onlytext'"
                            v-html="item.title"
                        ></span>
                        <Link
                            v-else
                            :link="item"
                            v-html="item.title"
                            :id="`${item.title}-nav`"
                        ></Link>
                    </li>
                </ul>
                <!-- <div class="newsletter">
                    <input type="text" placeholder="Sign up to our newsletter" />
                    <button type="submit">Submit</button>
                </div> -->
            </nav>
        </div>
    </header>
</template>

<script>
import Link from "@/components/ui/Link.vue";
// import { EventBus } from '@/events/bus.js';

export default {
    name: "site-header",

    data() {
        return {
            navi: [],
            menus: [],
            link: "",
            text: "",
            is_show_mobile_sub_menus: false,
            showBackHomeLink: false
        };
    },

    watch: {
        "$route.params": {
            handler() {
                // setting showBackHomeLink on first load on line 228
                // setting showBackHomeLink on route change here
                if (this.$route.name !== "home" && !this.showBackHomeLink) {
                    return (this.showBackHomeLink = true);
                } else if (
                    this.$route.name === "home" &&
                    this.showBackHomeLink
                ) {
                    return (this.showBackHomeLink = false);
                }
            },
            immediate: true
        }
    },

    components: {
        Link
    },

    methods: {
        toogleMobileMenus(menu) {
            let is_open = !menu.show_sub_menu;
            this.navi.forEach(item => {
                item.show_sub_menu = false;
            });

            menu.show_sub_menu = is_open;
            this.is_show_mobile_sub_menus = is_open;
        },
        showNavi(t) {
            if (!this.$store.state.is_disabled && window.innerWidth > 780)
                this.$store.state.show_navi = t;
        }
    },
    mounted() {
        this.is_mobile = window.innerWidth < 768;

        if (window.location.pathname !== "/" && !this.showBackHomeLink) {
            this.showBackHomeLink = true;
        }

        this.$ajax.get("/menus/2").then(res => {
            res.data.items.forEach(item => {
                item.show_sub_menu = false;
            });
            this.navi = res.data.items;
        });

        if (window.innerWidth >= 780) {
            this.$ajax.get("/menus/6").then(res => {
                this.menus = res.data.items;
            });
        }

        this.$ajax.get("/options").then(res => {
            this.link = res.data.header.link;
            this.text = res.data.header.text;
        });
    }
};
</script>

<style lang="scss">
.header {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 9999;
    width: 100%;
    color: white;
    background: var(--blue);
    transform: translate(0, calc(100% - 5.3rem));
    transition: transform 0.8s;

    .mobile-item {
        display: none;
    }

    &.show-navi {
        transform: translate(0, 0%);

        .navi {
            padding-top: var(--padding);
        }

        .logo {
            span {
                opacity: 0;
            }

            svg {
                opacity: 1;
            }
        }
    }

    a,
    a:visited {
        color: white;
    }

    .page-inner {
        position: relative;
    }

    .logo {
        width: 33.33%;
        position: relative;
        order: 2;
        text-align: right;

        span {
            opacity: 1;
            transition: opacity 0.25s ease;
        }

        svg {
            display: block;
            width: 60%;
            position: absolute;
            right: 0;
            bottom: 0;
            fill: white;
            opacity: 0;
            transition: opacity 0.2s ease-out;
            &:hover {
                transform: scale(0.95);
            }
        }
    }

    .navi {
        padding: calc(var(--padding) - 1rem) var(--padding) 0;
        display: flex;
        order: 1;
        position: relative;

        .link {
            position: absolute;
            width: 25%;
            right: 0;
            top: calc(var(--margin) * 1.8);
            font-size: var(--small-size);
            z-index: 1;

            &:hover {
                text-decoration: underline;
            }
        }

        .homepage-link {
            width: 25%;
            display: none;
            position: absolute;
            right: 0;
            top: var(--padding);
            font-size: var(--base-size);
            z-index: 1;

            &:hover {
                text-decoration: underline;
            }
        }

        .show-return-link {
            display: block;
        }

        & > ul {
            display: flex;
            flex-wrap: wrap;
            width: 66.66%;
        }

        .menu-item {
            width: 33.33%;
            box-sizing: border-box;
            padding-bottom: var(--padding);
            padding-right: var(--padding);

            h3 {
                padding-bottom: calc(var(--padding-50) + 0.6rem);
            }
        }

        .sub-menu-item {
            font-size: var(--small-size);
            margin: 0;
            line-height: 1.25;

            &.only-text {
                margin-bottom: var(--padding-50);
            }
        }

        li {
            line-height: 1;

            a:hover {
                text-decoration: underline;
            }

            &.menu-home-page {
                display: none;
            }

            &.current a {
                text-decoration: underline;
            }
        }
    }

    .menus {
        padding: 0 var(--padding) var(--padding);
        display: flex;
        box-sizing: border-box;
        width: 100%;
        align-items: flex-end;

        ul {
            display: flex;
            font-size: var(--tiny-size);
            flex: 1;

            li {
                padding-right: var(--padding-25);

                a:hover {
                    text-decoration: underline;
                }
            }
        }

        // .newsletter {
        //     input {
        //         background: transparent;
        //         border: none;
        //         color: white;
        //         font-size: var(--small-size);
        //         width: 20rem;
        //         border-bottom: .15rem solid;
        //         margin-right: var(--padding-50);
        //         padding-bottom: .5rem;
        //         position: relative;
        //         top: -.3rem ;

        //         &::placeholder {
        //             color: white;
        //         }
        //     }

        //     button {
        //         border: .15rem solid;
        //         color: white;
        //         background: transparent;
        //         border-radius: 0;
        //         padding: .3rem 1rem;
        //         font-size: var(--small-size);
        //     }
        // }
    }
}

@media only screen and (max-width: 767px) {
    .header {
        color: white;
        transform: unset;
        transition: unset;
        top: 0;
        overflow: hidden;
        bottom: auto;

        .mobile-item {
            padding: var(--padding-50) var(--padding) var(--padding-50);
            display: flex;
            align-items: center;
            font-size: var(--title-size);
            box-sizing: border-box;
            width: 100%;

            span {
                flex: 1;
                position: relative;
                text-align: right;
            }

            svg {
                height: 6rem;
                width: 6rem;
                position: absolute;
                right: 0;
                top: 50%;
                margin: -3rem 0 0;
            }
        }

        &.show-navi {
            transform: unset;
            height: 100%;
            overflow: auto;
            display: grid;
            grid-template-rows: auto 1fr;
            grid-template-columns: 100%;

            .mobile-item {
                position: relative;

                &:before {
                    height: 0.5rem;
                    position: absolute;
                    content: "";
                    left: var(--padding);
                    right: var(--padding);
                    background: white;
                    bottom: -1.6rem;
                }
            }

            .page-inner {
                display: grid;
                grid-template-rows: 1fr auto;
                grid-template-columns: 100%;
                overflow: auto;
            }

            .navi {
                padding-top: var(--padding-50);
            }
        }

        &.is-show-mobile-sub-menus .logo {
            display: none;
        }

        .page-inner {
            display: none;
            padding: 0;
        }

        .logo {
            display: block;
            position: absolute;
            bottom: var(--padding);
            right: var(--padding);
            width: 30rem;
            height: 18rem;
            // pointer-events: none;

            svg {
                width: 100%;
            }
        }

        .navi {
            padding: var(--padding-50) var(--padding);
            display: block;
            order: unset;

            .link {
                display: none;
            }

            .homepage-link {
                display: none;
            }

            & > ul {
                display: block;
                width: auto;

                & > .menu-item {
                    width: auto;
                    padding: 0;
                    border-bottom: 0.5rem solid white;

                    &.show-sub-menu {
                        & > h3 {
                            &:after {
                                content: "↑";
                            }
                        }

                        > ul {
                            display: block;
                        }
                    }

                    &.menu-offices {
                        h3 {
                            &:before {
                                display: block;
                                content: "Contact";
                                width: 93%;
                            }
                            span {
                                display: none;
                            }
                        }
                    }
                }

                & > .menu-item > h3 {
                    font-size: var(--title-size);
                    padding: var(--padding-50) 0;
                    display: flex;

                    a,
                    span {
                        flex: 1;
                    }

                    &:after {
                        content: "↓";
                        flex: 1;
                        text-align: right;
                        display: block;
                        max-width: 7rem;
                        width: 7rem;
                        text-align: center;
                    }
                }

                & > .menu-item > ul {
                    display: none;

                    .sub-menu-item {
                        font-size: var(--title-size);
                        padding: 0 0 var(--padding-50) 0;
                        &.only-text {
                            margin-bottom: 0;
                        }
                    }
                }
            }
        }

        .menus {
            display: none;
        }
    }
}

@media print {
    .header {
        display: none !important;
    }
}
</style>
